import React from "react";
import BotaoDefinicoes from "../../Geral/_Aux/BotaoDefinicoes";
import noimage from "../../images/noimage.png";
import moment from "moment";

import InitialsAvatar from "../../shared/components/InitialsAvatar";

const Colaborador = ({ primeiro, colaborador, tem_definicoes, menu, menuMobile, filtro, paddingLeft, tag, organismos }) => {
    const montarDiasAusente = data => {
        const totalDias = moment().diff(moment(data, "DD/MM/YYYY"), "days");
        if (totalDias > 0)
            return (
                <div className="bloco-total-dias-ausente">
                    <span
                        className={`total-dias-ausente ${totalDias > 7 ? "ausente-acima" : "ausente-normal"}`}
                        title="Número de dias ausente no curso"
                    >
                        {totalDias} {totalDias > 1 ? "dias" : "dia"}
                    </span>
                </div>
            );
    };

    return (
        <>
            <div className="colaborador colaborador-desktop" style={paddingLeft}>
                <div className="info-participante">
                    <div className="container-img">
                        {colaborador.foto ? (
                            <img src={colaborador.foto} />
                        ) : (
                            <InitialsAvatar name={colaborador.nome_completo} size="small" />
                        )}
                    </div>
                    <div className="info">
                        <span className="nome">{colaborador.nome_completo}</span>
                        {colaborador.organismo && organismos && (
                            <span className="tag-organismo" title="Organismo">
                                {colaborador.organismo}
                            </span>
                        )}
                        <div className="bottom">
                            <span className="email">
                                {colaborador.email} ({colaborador.nr_aluno})
                                {!filtro ? (
                                    colaborador.role != "UTILIZADOR" ? (
                                        <span className="tag">{colaborador.role === "ENTIDADE" ? "Gestor" : "Instrutor"}</span>
                                    ) : null
                                ) : tag ? (
                                    <span className="tag">{tag}</span>
                                ) : null}{" "}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="entidadeUser">
                    {colaborador.emp_nome && (
                        <>
                            <div className="container-img">
                                <img src={colaborador.emp_logo ? colaborador.emp_logo : noimage} alt="Foto" />
                            </div>
                            <div className="head">
                                <span className="nome">{colaborador.emp_nome}</span>
                            </div>
                        </>
                    )}
                </div>
                <div className="ultimoLoginUser">
                    {colaborador.ultimoLogin && (
                        <>
                            {primeiro && <label>Último login</label>}
                            <div>
                                <span className="ultimo-acesso">{colaborador.ultimoLogin}</span>
                                {montarDiasAusente(colaborador.ultimoLogin)}
                            </div>
                        </>
                    )}
                </div>
                {tem_definicoes ? <BotaoDefinicoes menu={menu} /> : null}
            </div>
            <div className="colaborador colaborador-mobile" style={paddingLeft}>
                <div className="info-participante">
                    <div className="container-img">
                        {colaborador.foto ? (
                            <img src={colaborador.foto} />
                        ) : (
                            <InitialsAvatar name={colaborador.nome_completo} size="small" />
                        )}
                    </div>
                    <div className="info">
                        <span className="nome">{colaborador.nome_completo}</span>
                        {colaborador.organismo && organismos && (
                            <span className="tag-organismo" title="Organismo">
                                {colaborador.organismo}
                            </span>
                        )}
                        <div className="bottom">
                            <span className="email">
                                {colaborador.email} ({colaborador.nr_aluno})
                                {!filtro ? (
                                    colaborador.role != "UTILIZADOR" ? (
                                        <span className="tag">{colaborador.role === "ENTIDADE" ? "Gestor" : "Instrutor"}</span>
                                    ) : null
                                ) : tag ? (
                                    <span className="tag">{tag}</span>
                                ) : null}{" "}
                            </span>
                        </div>
                    </div>
                </div>
                {tem_definicoes ? <BotaoDefinicoes menu={menuMobile} /> : null}
            </div>
        </>
    );
};

export default Colaborador;
